export const experiences = [
  {
    role: "Software Engineer",
    company: "VIRAL NATION",
    companyUrl: "https://www.viralnation.com/",
    startDate: "March 2023",
    endDate: "Present",
    overview:
      "Led the development of VN Empower, enhancing employee collaboration and social media engagement. Optimized system reliability and performance by 75% with technologies like Java, Spring Boot, and PostgreSQL.",
    technologies: [
      "Java",
      "Spring Boot",
      "Node.js",
      "React",
      "Redux",
      "PostgreSQL",
      "MongoDB",
      "Redis",
      "AWS",
      "Stripe",
    ],
  },
  {
    role: "Student Researcher",
    company: "WIMTACH",
    companyUrl: "https://wimtach.centennialcollege.ca/",
    startDate: "October 2022",
    endDate: "March 2023",
    overview:
      "Developed high-performance applications and integrated AWS services to improve internal operations by 40%. Led full-stack development with React, Node.js, and AWS Lambda.",
    technologies: [
      "React",
      "Node.js",
      "AWS Lambda",
      "AWS EC2",
      "DynamoDB",
      "Neptune Graph",
      "Docker",
      "Jenkins",
    ],
  },
  {
    role: "Frontend Developer",
    company: "Eccentric Engine",
    companyUrl: "https://weareeccentric.com/",
    startDate: "August 2021",
    endDate: "December 2021",
    overview:
      "Developed Angular web applications and integrated Razorpay for seamless payment processing for key automotive clients like Mahindra and Tata Motors.",
    technologies: [
      "Angular",
      "JavaScript",
      "TypeScript",
      "Spring Boot",
      "Razorpay",
    ],
  },
  {
    role: "Software Developer",
    company: "Augmented TechLabs",
    companyUrl: "https://www.augmentedtechlabs.com/",
    startDate: "July 2020",
    endDate: "August 2021",
    overview:
      "Developed an Angular-based application for a law firm to automate reporting and client management, improving efficiency and accuracy.",
    technologies: ["Angular", "Node.js", "MongoDB", "Express.js"],
  },
  {
    role: "Ex-Full Stack Intern",
    company: "Quicko",
    companyUrl: "https://www.quicko.com/",
    startDate: "January 2020",
    endDate: "June 2020",
    overview:
      "Developed various web applications during my internship, including an API Dashboard and Tax Calendar. Contributed to the Orders and Plans apps (not live).",
    technologies: ["Angular", "API", "JavaScript", "TypeScript", "Spring Boot"],
    projects: [
      "API Dashboard: [dashboard.api.quicko.com/#/get-started](https://dashboard.api.quicko.com/#/get-started)",
      "Tax Calendar: [calendar.quicko.com](https://calendar.quicko.com)",
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: "Chess Game",
    description:
      "A modern chess game implementation inspired by Chess.com, featuring real-time gameplay and interactive board. Continuously adding new features and improvements.",
    tech: ["React", "TypeScript", "CSS"],
    github: "https://github.com/aryan411/chess-with-llm",
    demo: "https://aryan411.github.io/chess-with-llm/",
  },
  {
    id: 2,
    title: "Micro Frontend Demo",
    description:
      "Demonstration of micro-frontend architecture using Module Federation with multiple Angular applications - Movie List and Search Movies",
    tech: ["Angular", "Module Federation", "TypeScript", "Angular Material"],
    github: "https://github.com/aryan411/movie-app",
  },
];
